import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ensureDashboardsEnabled } from '@/features/dashboards/guard.js';
import { DashboardsView } from '@/features/dashboards/DashboardsView.js';

/**
 * Index route for `/dashboards`: every saved dashboard stacked on one page. The index and the
 * `/dashboards/$id` page are siblings under an implicit parent so the single dashboard does not render
 * the list. Pure SPA route — data comes from /v1/dashboards via TanStack Query.
 */
export const Route = createFileRoute('/dashboards/')({
  beforeLoad: () => ensureDashboardsEnabled(),
  component: DashboardsPage,
});

function DashboardsPage(): JSX.Element {
  return <DashboardsView />;
}
